<nz-spin [nzSpinning]="loading$ | async">
  <div class="drawer-form-wrapper without-bottom-cta full-height">
    <div class="behaviour-card-sec">
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">
          {{
            caseParams.case?.student?.firstName +
              ' ' +
              caseParams.case?.student?.lastName
          }}
        </h3>
      </div>
      <div class="card-content-wrapper">
        <div class="content">
          <h4 class="title">Date Of Birth</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-calendar.svg"
              class="icon s-16"></svg-icon>
            {{
              caseParams.case?.student?.dateOfBirth ?? null | date: 'MM/dd/yyyy'
            }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Supervisor</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-supervisor.svg"
              class="icon s-16"></svg-icon>
            {{ caseParams.case?.supervisorName }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Gender</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-male.svg"
              class="icon s-16"></svg-icon>
            {{ caseParams.case?.student?.gender }}
          </p>
        </div>
      </div>
    </div>
    <div class="header-with-cta without-border">
      <div class="cta-wrapper">
        <button nz-button nzType="primary" (click)="isAddFolderOpen = true">
          Add Folder
        </button>
      </div>
    </div>
    <div class="attachments-list">
      <div *ngIf="!!generalAttachmentData; else customNoResult">
        <div class="header-with-cta without-border">
          <h3 class="title s-18">{{ generalAttachmentData.title }}</h3>
          <div class="cta-wrapper">
            <ng-container>
              <button
                nz-button
                nzType="default"
                [disabled]="selectedCount(generalAttachmentData.folders) === 0"
                (click)="downloadSelectedAttachments(generalAttachmentData)"
                class="mr-8">
                Download Selected ({{
                  selectedCount(generalAttachmentData.folders)
                }})
              </button>
              <button
                nz-button
                nzType="default"
                (click)="downloadAllAttachments(generalAttachmentData)"
                class="mr-8">
                Download All
              </button>
            </ng-container>
            <button
              nz-button
              nzType="primary"
              (click)="openAddAttachmentComponentDrawer(generalAttachmentData)">
              Add Attachment
            </button>
          </div>
        </div>
        <div
          class="bulk-actions"
          *ngIf="generalAttachmentData.folders.length > 0; else customNoResult">
          <!--todo: this will be fixed in next ng-zorro-antd update // -->
          <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
          <label
            nz-checkbox
            [(ngModel)]="selectAll"
            (ngModelChange)="onSelectAllChange(generalAttachmentData.folders)">
            Select All
          </label>
        </div>
        <nz-collapse [nzBordered]="false" [nzExpandIconPosition]="'end'">
          <nz-collapse-panel
            *ngFor="let folder of generalAttachmentData.folders; let i = index"
            [nzHeader]="folderTemplate"
            [(nzActive)]="folder.active"
            (nzActiveChange)="
              onFolderExpand(generalAttachmentData.folders, i, $event)
            "
            [nzExtra]="extraTpl">
            <ng-template #folderTemplate>
              <div nzFlex>
                <!--todo: this will be fixed in next ng-zorro-antd update // -->
                <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
                <label
                  nz-checkbox
                  [(ngModel)]="folder.selected"
                  (ngModelChange)="
                    onSelectFolderChange(
                      generalAttachmentData.folders,
                      folder.folderId
                    )
                  ">
                  <span class="folder-name">{{ folder.folderName }}</span>
                </label>
              </div>
            </ng-template>
            <div
              class="file-upload-preview"
              *ngFor="let attachment of folder.attachments">
              <div class="file-upload-preview-item">
                <div>
                  <!--todo: this will be fixed in next ng-zorro-antd update // -->
                  <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
                  <label
                    nz-checkbox
                    [(ngModel)]="attachment.selected"
                    (ngModelChange)="
                      onAttachmentSelectionChange(generalAttachmentData.folders)
                    ">
                  </label>
                </div>
                <div
                  class="file"
                  (click)="viewAttachmentDetails(attachment)"
                  (keyup.enter)="viewAttachmentDetails(attachment)"
                  tabindex="0"
                  role="button">
                  <svg-icon
                    class="f-shrink"
                    [title]="'View Attachment'"
                    src="/assets/icon/icon-report-green.svg"></svg-icon>
                  <div class="about-file">
                    <h4 class="file-name resize">{{ attachment.name }}</h4>
                    <p class="file-description text s-14">
                      {{ attachment.description }}
                    </p>
                    <p class="file-desc">{{ attachment.fileSize }}</p>
                  </div>
                </div>
              </div>
              <div class="actions">
                <button
                  class="f-shrink"
                  nz-button
                  nzType="text"
                  (click)="onDelete(attachment.id)">
                  <svg-icon
                    [title]="'Delete Attachment'"
                    src="/assets/icon/icon-trash.svg"
                    class="icon s-20"></svg-icon>
                </button>
                <button
                  class="f-shrink"
                  nz-button
                  nzType="text"
                  (click)="downloadFile(attachment)">
                  <svg-icon
                    [title]="'Download Attachment'"
                    src="/assets/icon/icon-download.svg"></svg-icon>
                </button>
              </div>
            </div>
            <ng-template #extraTpl>
              <button
                type="button"
                nz-button
                nzType="default"
                aria-label="Settings"
                class="collapse-btn">
                <svg-icon
                  [src]="
                    folder?.active
                      ? '/assets/icon/icon-minus.svg'
                      : '/assets/icon/icon-plus.svg'
                  "
                  class="icon s-12"></svg-icon>
              </button>
            </ng-template>
          </nz-collapse-panel>
        </nz-collapse>
      </div>

      <div *ngIf="planData.length > 0">
        <ng-container *ngFor="let plan of planData">
          <div class="header-with-cta without-border">
            <h3 class="title s-18">{{ plan.title }}</h3>
            <div class="cta-wrapper">
              <ng-container>
                <button
                  *ngIf="plan.folders.length > 0"
                  nz-button
                  nzType="default"
                  [disabled]="selectedCount(plan.folders) === 0"
                  (click)="downloadSelectedAttachments(plan)"
                  class="mr-8">
                  Download Selected ({{ selectedCount(plan.folders) }})
                </button>
                <button
                  *ngIf="plan.folders.length > 0"
                  nz-button
                  nzType="default"
                  (click)="downloadAllAttachments(plan)"
                  class="mr-8">
                  Download All
                </button>
              </ng-container>
              <button
                nz-button
                nzType="default"
                (click)="openAddAttachmentComponentDrawer(plan)">
                Add Attachment
              </button>
              <button
                nz-button
                nzType="primary"
                (click)="openAttemptQuestionnaireDrawer(plan)">
                Attempt Questionaire
              </button>
            </div>
          </div>
          <div class="bulk-actions" *ngIf="plan.folders.length > 0">
            <!--todo: this will be fixed in next ng-zorro-antd update // -->
            <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
            <label
              nz-checkbox
              [(ngModel)]="selectAll"
              (ngModelChange)="onSelectAllChange(plan.folders)">
              Select All
            </label>
          </div>
          <div *ngIf="plan.folders.length > 0; else customNoResult">
            <nz-collapse [nzBordered]="false" [nzExpandIconPosition]="'end'">
              <nz-collapse-panel
                *ngFor="let folder of plan.folders; let i = index"
                [nzHeader]="folderTemplate"
                [(nzActive)]="folder.active"
                (nzActiveChange)="onFolderExpand(plan.folders, i, $event)"
                [nzExtra]="extraTpl">
                <ng-template #folderTemplate>
                  <div nzFlex>
                    <!--todo: this will be fixed in next ng-zorro-antd update // -->
                    <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
                    <label
                      nz-checkbox
                      [(ngModel)]="folder.selected"
                      (ngModelChange)="
                        onSelectFolderChange(plan.folders, folder.folderId)
                      ">
                      <span class="folder-name">{{ folder.folderName }}</span>
                    </label>
                  </div>
                </ng-template>
                <div
                  class="file-upload-preview"
                  *ngFor="let attachment of folder.attachments">
                  <div class="file-upload-preview-item">
                    <div>
                      <!--todo: this will be fixed in next ng-zorro-antd update // -->
                      <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
                      <label
                        nz-checkbox
                        [(ngModel)]="attachment.selected"
                        (ngModelChange)="
                          onAttachmentSelectionChange(plan.folders)
                        ">
                      </label>
                    </div>
                    <div
                      class="file"
                      (click)="viewAttachmentDetails(attachment, plan.id)"
                      (keyup.enter)="viewAttachmentDetails(attachment, plan.id)"
                      tabindex="0"
                      role="button">
                      <svg-icon
                        class="f-shrink"
                        [title]="'View Attachment'"
                        src="/assets/icon/icon-report-green.svg"></svg-icon>
                      <div class="about-file">
                        <h4 class="file-name resize">{{ attachment.name }}</h4>
                        <p class="file-description text s-14">
                          {{ attachment.description }}
                        </p>
                        <p class="file-desc">{{ attachment.fileSize }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="actions">
                    <button
                      class="f-shrink"
                      nz-button
                      nzType="text"
                      (click)="onDelete(attachment.id)">
                      <svg-icon
                        [title]="'Delete Attachment'"
                        src="/assets/icon/icon-trash.svg"
                        class="icon s-20"></svg-icon>
                    </button>
                    <button
                      class="f-shrink"
                      nz-button
                      nzType="text"
                      (click)="downloadFile(attachment)">
                      <svg-icon
                        [title]="'Download Attachment'"
                        src="/assets/icon/icon-download.svg"></svg-icon>
                    </button>
                  </div>
                </div>
                <ng-template #extraTpl>
                  <button
                    type="button"
                    nz-button
                    nzType="default"
                    aria-label="Settings"
                    class="collapse-btn">
                    <svg-icon
                      [src]="
                        folder?.active
                          ? '/assets/icon/icon-minus.svg'
                          : '/assets/icon/icon-plus.svg'
                      "
                      class="icon s-12"></svg-icon>
                  </button>
                </ng-template>
              </nz-collapse-panel>
            </nz-collapse>
          </div>
        </ng-container>
      </div>
      <ng-template #customNoResult>
        <nz-empty></nz-empty>
      </ng-template>
    </div>
  </div>
</nz-spin>
<app-confirm-dialog
  [isVisible]="showConfirmDialog"
  [title]="'Delete Attachment'"
  [message]="confrimDialogMsg"
  [iconSrc]="'/assets/icon/icon-trash-red.svg'"
  [iconColor]="'red'"
  [cancelText]="'Cancel'"
  [confirmText]="'Delete'"
  [loading]="isDeleting"
  (confirmed)="handleDelete()"
  (cancelled)="handleCancel()"
  (closed)="handleCancel()">
</app-confirm-dialog>

<app-confirm-dialog
  [isVisible]="isAddFolderOpen"
  title="Folder Name"
  message=""
  [iconSrc]="'/assets/icon/icon-folder-plus.svg'"
  [iconColor]="'green'"
  [cancelText]="'Cancel'"
  [messageTemplate]="folderTemplate"
  [primaryButtonClass]="'btn btn-primary'"
  [confirmText]="'Save'"
  (confirmed)="onSaveFolder()"
  (cancelled)="onCancelFolder()"
  (closed)="onCancelFolder()">
</app-confirm-dialog>

<ng-template #folderTemplate>
  <div class="drawer-form-wrapper mt-2">
    <form nz-form class="form" nzLayout="horizontal" [formGroup]="folderForm">
      <nz-form-item>
        <nz-form-control
          [nzErrorTip]="nameErrorTpl"
          [nzValidateStatus]="
            folderForm.get('name')?.invalid && folderForm.get('name')?.touched
              ? 'error'
              : ''
          ">
          <input
            name="Folder Name"
            type="text"
            nz-input
            id="name"
            formControlName="name"
            placeholder="Enter folder name" />
          <ng-template #nameErrorTpl>
            <ng-container *ngIf="folderForm.get('name')?.errors as errors">
              <span *ngIf="folderForm.get('name')?.errors?.['required']">
                Name is required
              </span>
              <span *ngIf="folderForm.get('name')?.errors?.['pattern']">
                Name is invalid
              </span>
              <span *ngIf="folderForm.get('name')?.errors?.['maxlength']">
                Name is not more than 50 characters
              </span>
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </form>
  </div>
</ng-template>
